<div class="row p-5 text-center">
  <img
    src="assets/img/icons/error.svg"
    width="72px"
    height="72px"
    alt="error"
   
  />
  <h2 class="blue-50 bold m-2">C'è stato un problema</h2>
  <p>La tua richiesta non è andata a buon fine.</p>
</div>
